const data = {
  "hemingway": {
    "entrances": {
      "questionnaire": "Start de keuzehulp"
    },
    "headerProposition": {
      "days": "Dagen",
      "hours": "Uur",
      "minutes": "Minuten",
      "seconds": "Seconden"
    },
    "productCard": {
      "formerPricePrefix": "Adviesprijs",
      "addToCartLabel": "In mijn winkelwagen",
      "mailerLabel": "Houd mij op de hoogte"
    },
    "manufacturersSpecifications": {
      "drawerLabel": "Leveranciersinformatie"
    },
    "productLineComparison": {
      "minutes": "min",
      "priceRange": "Vanaf <lowestPrice /> tot <highestPrice />",
      "priceRangeSingle": "Vanaf <lowestPrice />"
    },
    "inspirational": {
      "productButton": "Bekijk product"
    },
    "newsletter": {
      "emailAddressLabel": "E-mailadres",
      "signUp": "Aanmelden",
      "helperText": "Je kunt je op elk moment afmelden.",
      "emailEmpty": "Er is geen e-mailadres ingevuld.",
      "emailInvalid": "Oeps! Ongeldig e-mailadres. Probeer opnieuw",
      "subscriptionFailedMessage": "Er is iets mis gegaan bij het inschrijven.",
      "successConfirmation": "Je bent nu geabonneerd op de nieuwsbrief",
      "subscriptionSucceededMessage": "Je ontvangt binnen enkele minuten een e-mail op <strong>{{email}}</strong>. Hierin vind je een link om je abonnement te bevestigen."
    },
    "virtualAgent": {
      "new": "nieuw"
    }
  }
};

export default data;